import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ZawodnikLanding from './ZawodnikLanding';
import ZawodnikRally from './ZawodnikRally';
import ZawodnikClimb from './ZawodnikClimb';
import Elearning from './Elearning';
import Polityka from './Polityka';

const root = ReactDOM.createRoot(document.getElementById('root'));
const path = window.location.pathname.toLowerCase();
const isZawodnik = path === '/zawodnik' || path === '/zawodnik/';
const isZawodnikRally = path === '/zawodnik-rally' || path === '/zawodnik-rally/';
const isZawodnikClimb = path === '/zawodnik-climb' || path === '/zawodnik-climb/';
const isElearning = path === '/elearning' || path === '/elearning/';
const isPolityka = path === '/polityka-prywatnosci' || path === '/polityka-prywatnosci/';

root.render(
  <React.StrictMode>
    {isZawodnik ? <ZawodnikLanding /> :
     isZawodnikRally ? <ZawodnikRally /> :
     isZawodnikClimb ? <ZawodnikClimb /> :
     isElearning ? <Elearning /> :
     isPolityka ? <Polityka /> :
     <App />}
  </React.StrictMode>
);